import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCar,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionEquipment/video/rtlsVideo.mp4';
import subVideo1 from '@src/assets/images/solution/constructionEquipment/video/sub/rtlsVideo2.mp4';

import image1 from '@src/assets/images/solution/constructionEquipment/img/1.avif';
import image2 from '@src/assets/images/solution/constructionEquipment/img/2.avif';
import image3 from '@src/assets/images/solution/constructionEquipment/img/3.avif';
import image4 from '@src/assets/images/solution/constructionEquipment/img/4.avif';
import image5 from '@src/assets/images/solution/constructionEquipment/img/5.avif';
import image6 from '@src/assets/images/solution/constructionEquipment/img/6.avif';
import image7 from '@src/assets/images/solution/constructionEquipment/img/7.avif';
import recommendation from '../common/recommendation';
import { constructionEquipment1, constructionEquipment2, recommendationServer } from '@assets/images/solution/recommendation';

export default {
  type: '건설 솔루션',
  banner: {
    title: '크레인의 움직임을 실시간으로 감지해 작업자의 안전을 확보하세요',
    desc: '위치 감지 기술로 크레인의 운행 범위를 추적하고 작업자 접근 시 자동으로 경고를 전송합니다',
  },

  recommend: {
    title: '크레인의 움직임을 추적해 충돌 위험을 사전에 감지합니다',
    desc: '크레인에 설치된 위치 송신기와 작업자의 태그를 연동해 이동 데이터를 수집하고, 접근 시 경고를 자동 전송합니다',
    labels: {
      desktop: [
        {
          img: constructionEquipment1,
          data: recommendation.twintarckerUWB,
        },
        {
          img: constructionEquipment2,
          data: recommendation.uwbTag,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
      ],
      mobile: [
        {
          data: recommendation.uwbTag,
        },
        {
          data: recommendation.twintarckerUWB,
        },
        {
          data: recommendation.server,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },
  video: {
    title: '크레인 위치 데이터를 통해 현장 안전과 효율성을 동시에 높이세요.',
    desc: '크레인의 위치와 작업자의 움직임을 실시간으로 모니터링하여 안전사고를 예방하고, 현장의 운영 효율성과 안전 관리 능력을 디지털화합니다.',
    play: mainVideo,
  },

  func: [
    {
      theme: '크레인과 작업자의 위치 데이터를 활용해 작업 현장 안전을 강화하세요.',
      title: '크레인 위치 실시간 모니터링',
      desc: '크레인의 위치를 실시간으로 정확하게 추적하여 작업자가 크레인의 위험 구역에 접근 시 즉시 경고 알림을 발송하고 안전 조치를 자동화합니다. 이를 통해 작업자의 안전성을 크게 향상시킬 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '컨테이너 밀집 구역 내 작업자 위치 관리',
      desc: '크레인이 컨테이너 밀집 지역에서 작업할 때 실시간 위치를 파악하여 컨테이너 작업자와 충돌 위험이 없도록 안전 구역을 자동 설정합니다. 작업자가 있는 위치에 컨테이너를 내려놓지 않도록 미리 경고 알림을 보냅니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '크레인과 컨테이너 간 거리 실시간 측정 및 충돌 예방',
      desc: '크레인과 컨테이너의 정확한 거리와 위치를 실시간으로 추적하여 크레인의 이동 경로를 예측하고 잠재적인 충돌 위험을 사전에 방지합니다. 충돌 위험 시 작업자를 자동으로 대피시키고 크레인 동작을 즉시 정지시킵니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '중장비 통합 위치 모니터링 및 관리',
      desc: '크레인뿐만 아니라 지게차, 야드 트럭 등 다양한 중장비의 실시간 위치를 통합적으로 관리하고 모니터링합니다. 장비 간 충돌 방지 및 현장 안전성 강화를 위한 정확한 정보를 제공합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo1,
    },
    {
      theme: '디지털 전환을 통한 현장 운영 효율성과 안전성을 동시에 높이세요.',
      title: '실시간 운영 상황 통합 관제',
      desc: '현장의 모든 크레인과 작업자의 실시간 위치 데이터를 한눈에 통합 관리하여 효율적인 현장 운영과 신속한 의사결정을 지원합니다. 디지털 관제 시스템을 통해 사고 위험을 최소화하고 관리자의 피로도를 크게 낮출 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image4,
    },
    {
      title: '디지털 전환 기반 재난 자동 대응',
      desc: '사고 발생 시 자동으로 현장 대응 프로세스가 작동되어 사고 피해를 최소화하고 신속한 대응이 가능합니다. 디지털 시나리오 기반으로 체계적이고 효율적인 현장 재난 관리를 실현합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: '작업자 및 중장비 이동 이력 자동 기록 및 분석',
      desc: '크레인과 중장비, 작업자의 이동 경로와 작업 이력을 자동으로 기록하여 운영 상태를 정확히 분석합니다. 이를 통해 현장 생산성과 안전성을 지속적으로 개선하고, 문제 발생 시 신속한 원인 분석과 대응을 지원합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '간편한 설치와 유지보수를 통한 크레인 안전 시스템 구축',
      desc: '컨테이너 위에서도 쉽게 설치 가능한 위치추적 장치를 이용해 크레인의 실시간 위치를 정확히 관리합니다. 시스템 설치 및 유지보수가 간편해 현장 작업자의 안전을 즉각적으로 강화하고 운영 효율을 지속적으로 유지할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image7,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '',

    data: [
      {
        icon: IconWarning, // 접근 경고 → 위험 경고 의미
        title: '작업자 접근 경고',
        desc: '작업자 밀집도와 이동량을 분석해 공간별 인력 배치를 최적화하고 안전성과 효율을 높입니다.',
      },
      {
        icon: IconCar, // 크레인 하강 → 중장비 제어 의미로 Car 사용
        title: '하강 자동 제어',
        desc: '컨테이너 구역에서 작업자 위치를 감지해 크레인의 하강을 자동으로 제한합니다.',
      },
      {
        icon: IconCar, // 충돌 정지 → 중장비 정지 → Car 재사용
        title: '충돌 자동 정지',
        desc: '크레인과 컨테이너 간 거리를 측정해 충돌 위험 시 즉시 동작을 정지시킵니다.',
      },
      {
        icon: IconLayers, // 장비 통합 관리 → 위치 기반 통합 Layers 의미
        title: '중장비 통합 관리',
        desc: '여러 장비의 위치를 통합 관리해 장비 간 충돌을 사전에 방지합니다.',
      },
      {
        icon: IconCctvLine, // 관제 연동 → 실시간 시각 정보 → CCTV 사용
        title: '실시간 관제 연동',
        desc: '작업자와 장비의 위치를 실시간으로 통합해 관제 화면에서 즉시 확인합니다.',
      },
      {
        icon: IconWarning, // 디지털 대응 → 위험 발생 시 절차 → Warning 적합
        title: '디지털 대응 시나리오',
        desc: '위험 발생 시 작업자 대피, 장비 정지 등 대응 절차가 자동으로 실행됩니다.',
      },
      {
        icon: IconRoute, // 이동 이력 기록 → 경로 추적
        title: '이동 이력 기록',
        desc: '크레인의 회전 경로와 작업자 이동 이력을 자동으로 저장하고 분석합니다.',
      },
      {
        icon: IconSearch, // 장비 설치 → 직접 설치/탐색 의미 → Search 활용
        title: '간편한 장비 설치',
        desc: 'UWB 기반 위치추적 장치를 간편하게 부착해 현장 운영에 바로 적용할 수 있습니다.',
      },
    ],
  },
  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
